export default __webpack_public_path__ + "static/APP_5-79f09911f96bef2ac6310466fcf8c2c2.png";